import { useCallback, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { ConsultationType, ConsultationStatus } from '@/core/models/consultation.model'
import { Room } from '@/core/models/room.model'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { createConsultation } from '@/redux/reducers/consultation.reducer'

import { isStaff } from '@/utils/type-guards'

type UseCreateEmergencyConsultationParams = {
  emergencyRoom: Room | null
}

export function useCreateEmergencyConsultation({ emergencyRoom }: UseCreateEmergencyConsultationParams) {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const authUser = useAppSelector(selectAuthUser)

  const hasBootstrappedFromQueue = useRef(false)

  // Auto-create consultation from queue navigation
  useEffect(() => {
    const patientId = location.state?.patientId

    if (!hasBootstrappedFromQueue.current && patientId && authUser && isStaff(authUser) && authUser.status === 'PDS' && !emergencyRoom?.currentConsultation) {
      hasBootstrappedFromQueue.current = true
      dispatch(
        createConsultation({
          consultation: {
            patient: patientId,
            pds: authUser._id,
            startDate: new Date().toISOString(),
            type: ConsultationType.Emergency,
            status: ConsultationStatus.Active,
          },
        })
      )
    }
  }, [dispatch, location, authUser, emergencyRoom])

  const handleSelectPatient = useCallback(
    (patientId: string) => {
      if (!authUser) return

      dispatch(
        createConsultation({
          consultation: {
            patient: patientId,
            pds: authUser._id,
            startDate: new Date().toISOString(),
            type: ConsultationType.Emergency,
            status: ConsultationStatus.Active,
          },
        })
      )
    },
    [dispatch, authUser]
  )

  return { handleSelectPatient }
}
